import { SC } from '../helper/ServerCall';
import { pathSegment } from '../helper/queryString';

export const destinationService = {
    getDestinationsPagination,
    storeDestination,
    getDestination,
    editAllDestination,
    editDestination,
    deleteDestination,
    destinationOrders,
    assignOrderDestination
}

function getDestinationsPagination(page, filter, sort, pageSize, is_active) {
    return SC.getCall('destinations', { page, filter, sort, pageSize, is_active });
}
function storeDestination(destinationData) {
    return SC.postCall('destinations', destinationData);
}
function assignOrderDestination(destinationId, destinationData) {
    return SC.postCall(`assignOrderDestination/${pathSegment(destinationId)}`, destinationData);
}
function getDestination(destinationId) {
    return SC.getCall(`destinations/${pathSegment(destinationId)}`);
}
function destinationOrders(destinationId) {
    return SC.getCall(`destinationOrders/${pathSegment(destinationId)}`);
}
function editDestination(destinationData, destinationId) {
    return SC.putCall(`destinations/${pathSegment(destinationId)}`, destinationData);
}
function editAllDestination(destinationId, destinationData) {
    return SC.putCall('destinations/allData', destinationId, destinationData);
}
function deleteDestination(destinationId) {
    return SC.deleteCall(`destinations/${pathSegment(destinationId)}`);
}

